<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-portulans shape-skew"></div>
        <div
          class="container shape-container d-flex"
          style="padding-bottom: 7rem"
        >
          <div class="col px-0">
            <div class="row">
              <div
                class="col-12"
                style="display: flex; align-items: center; flex-wrap: wrap"
              >
                <img
                  src="/img/brand/descartes_institute.png"
                  style="width: 100px; margin-bottom: 40px; margin-right: 40px"
                  class="float-left"
                />
                <img
                  src="/img/brand/we-go-logo.png"
                  style="width: 220px; margin-bottom: 40px; margin-right: 45px"
                  class="float-left"
                />
              </div>
              <div class="col-lg-12">
                <h1 class="font-weight-700 mt-4">
                  Assessing Cities Future Readiness
                </h1>
                <hr />
                <p class="lead">
                  In a growing number of areas, cities now set the pace for
                  global progress. In doing so, they open new paths to
                  future-readiness.
                  <br />
                  <br />
                  Yet ambition needs calibration. This report introduces a new,
                  data-rich framework to measure future readiness at the city
                  level, moving beyond perception surveys to comparable,
                  fact-based indicators. Powered by more rigorous and harmonized
                  datasets, it benchmarks what matters most for urban
                  competitiveness and resilience—human-centric services,
                  innovation capacity, sustainability performance, and the
                  ability to execute—so leaders can see where they stand and
                  what to do next.
                  <br />
                  <br />
                  The shift is structural. City-level data have matured,
                  priorities have broadened, and the global role of cities has
                  accelerated. Our methodology captures this inflection point
                  with transparent metrics, cross-city comparability, and
                  actionable insights. The result is a clear lens on who is
                  building future-ready systems today—and how others can close
                  the gap. Continue to the methodology to see how the index
                  works, or explore the rankings to find your city’s trajectory.
                </p>
              </div>
            </div>
            <br />
            <div class="col-lg-12 text-left mt-4">
              <div class="btn-wrapper">
                <base-button
                  tag="a"
                  href="https://drive.google.com/file/d/1JFvzERtVMEiJF4AGS2naX9GnkpCFAVYg/view"
                  target="_blank"
                  class="mb-3"
                  type="primary-green"
                  icon="fa fa-download"
                >
                  Cities Future Readiness Index Report
                </base-button>
                <base-button
                  tag="a"
                  href="/pdfs/CFRI Infographic Final.pdf"
                  target="_blank"
                  class="mb-3"
                  type="primary-green"
                  icon="fa fa-download"
                >
                  View Infrographics
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>

    <section
      class="section section-lg digital-sprinters bg-google"
      data-aos="fade-in"
      data-aos-offset="400"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-left">
            <h2 class="display-3">A POSITIVE model</h2>
            <p class="lead">
              The model underlying the Cities Future Readiness Index (CFRI) is
              built on an Input-Output framework. This approach distinguishes
              between a city’s enabling environment and endowments on the one
              hand, and the ability of a city to translate these resources into
              tangible outcomes on the other. The resulting model is structured
              around eight pillars, summarised by the acronym POSITIVE:
            </p>
            <div class="col-lg-12 mt-4">
              <ul>
                <li>People Centricity</li>
                <li>Openness</li>
                <li>Sustainability</li>
                <li>Institutions and Governance</li>
                <li>Transport and Infrastructure</li>
                <li>Innovation</li>
                <li>Vibrancy</li>
                <li>E-Readiness</li>
              </ul>
            </div>
            <p>
              The first five pillars belong to the Input dimension, whereas the
              final three form part of the Output dimension (see Figure X). Each
              pillar consists of two sub-pillars that, in turn, are composed of
              two to four variables. Altogether, the POSITIVE model is populated
              by 44 indicators: 32 based on quantitative data and 12 derived
              from index/composite indicator data.
            </p>
            <p>
              The model’s structure assigns each indicator to both a pillar and
              a sub-pillar. This relationship is captured in a three-digit
              prefix attached to each indicator name: the first digit denotes
              the pillar, the second the sub-pillar, and the third the specific
              indicator. For example, indicator 1.2.3 refers to the third
              indicator (Mean years of schooling), which belongs to the second
              sub-pillar (Access to Services) under the first pillar (People
              Centricity)
            </p>
            <div
              class="my-3"
              style="
                width: 100%;
                background-color: #dbe0f1;
                text-align: center;
                border-radius: 18px;
                overflow: hidden;
              "
            >
              <img
                data-v-6113bc73=""
                src="/img/brand/cfri-index.png"
                class="mb-5 mt-6 mx-auto"
                style="width: 100%; max-width: 800px"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div
            class="col-md-9 order-md-2"
            data-aos="fade-in"
            data-aos-offset="300"
          >
            <div class="pr-md-5">
              <h3>
                "Cities are taking a central role in shaping our common future.
                To better steer and coordinate our efforts, we need better
                metrics. Following WeGO’s mission of promoting the digital
                transformation of cities into human-centric smart cities, our
                collaboration on City Future Readiness Index (CFRI) aims at
                presenting urban decision makers with both metrics and vision
                that prioritize human-centric innovation when it comes to urban
                digital transformation"
              </h3>
              <p class="lead">
                <span class="font-weight-600">Jeong-kee Kim</span
                ><br />Secretary General, World Smart Sustainable Cities
                Organization - WeGO
              </p>
            </div>
          </div>
          <div
            class="col-md-3 order-md-1"
            data-aos="fade-right"
            data-aos-offset="300"
            style="margin: auto; text-align: center"
          >
            <img
              src="/img/photos/jeong_kee_kim.png"
              class="img-fluid"
              style="max-width: 220px; margin: auto"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="section section-lg">
      <div class="container">
        <div
          class="row row-grid align-items-center"
          data-aos="fade-in"
          data-aos-offset="300"
        >
          <div class="col-md-9 order-md-1" style="text-align: right">
            <div class="pr-md-3">
              <h3>
                "Like an alpinist facing the challenge of a yet unconquered
                summit, cities are opening new paths to the future. Their
                efforts are fraught with uncertainties, and the dangers that
                come with trying new approaches and adopting innovative
                strategies. Every day, new data becomes available to better
                describe the situation and dynamics of cities worldwide. Since
                our future will be mainly urban, assessing how our cities are
                prepared to face to-morrow’s challenges and seize the
                opportunities of the future is key to shaping the future as we
                want it to be."
              </h3>
              <p class="lead">
                <span class="font-weight-600">Bruno Lanvin</span><br />
                President, Descartes Institute
              </p>
            </div>
          </div>
          <div
            class="col-md-3 order-md-2"
            data-aos="fade-left"
            data-aos-offset="300"
            style="margin: auto; text-align: center"
          >
            <img
              src="/img/photos/bruno_lanvin.png"
              class="img-fluid"
              style="max-width: 220px; margin: auto"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  metaInfo: {
    title: "Descartes Institute CFRI 2025 | About",
  },
  data() {
    return {
      modalShow: false,
      visible: false,
    };
  },
  methods: {
    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
  },
};
</script>

<style scoped>
.methodology-box {
  background: white;
  padding: 1em;
  border-radius: 5px;
}

.google-colour-bar {
  height: 10px;
}

.google-red {
  background-color: #db4437;
}

.google-blue {
  background-color: #4285f4;
}

.google-green {
  background-color: #0f9d58;
}

.google-yellow {
  background-color: #f4b400;
}
</style>
